import { PROTOCOL_LABEL, PROTOCOL_ORDER } from '../lib/definitions/protocols';
import { useAppData } from "../state/AppData";

// A protocol toggle for Meshtastic / MeshCore / All. Only offers
// options for protocols that actually have a connected transport right now
// (per /api/health, not "have we happened to see a packet yet") — with
// fewer than two available there is nothing to toggle, so the control is
// absent entirely rather than shown disabled (the fleet's standing rule:
// nothing appears in the UI for something that isn't there).
export function ProtocolToggle() {
  const { availableProtocols, protocolFilter, setProtocolFilter } = useAppData();

  if (availableProtocols.length < 2) return null;

  const options = PROTOCOL_ORDER.filter((p) => availableProtocols.includes(p));

  return (
    <div className="theme-toggle" role="group" aria-label="Protocol">
      <button data-active={protocolFilter === "all"} onClick={() => setProtocolFilter("all")}>
        All
      </button>
      {options.map((p) => (
        <button key={p} data-active={protocolFilter === p} onClick={() => setProtocolFilter(p)}>
          {PROTOCOL_LABEL[p]}
        </button>
      ))}
    </div>
  );
}
